'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _agentTypingStatesRed;

var _immutable = require('immutable');

var _reduxActions = require('redux-actions');

var _setIn = require('transmute/setIn');

var _setIn2 = _interopRequireDefault(_setIn);

var _omit = require('transmute/omit');

var _omit2 = _interopRequireDefault(_omit);

var _updateIn = require('transmute/updateIn');

var _updateIn2 = _interopRequireDefault(_updateIn);

var _typingIndicatorActionTypes = require('../constants/typingIndicatorActionTypes');

var _getTypingTimeoutIdForAgentInThread = require('../operators/getTypingTimeoutIdForAgentInThread');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = (0, _immutable.Map)();

var agentTypingStatesReducer = (_agentTypingStatesRed = {}, _defineProperty(_agentTypingStatesRed, _typingIndicatorActionTypes.ADD_AGENT_TYPING_TIMEOUT_ID, function (state, action) {
  var _action$payload = action.payload,
      threadId = _action$payload.threadId,
      agentId = _action$payload.agentId,
      timeoutId = _action$payload.timeoutId;


  return (0, _setIn2.default)(['' + threadId, agentId], timeoutId, state);
}), _defineProperty(_agentTypingStatesRed, _typingIndicatorActionTypes.REMOVE_AGENT_TYPING_TIMEOUT_ID, function (state, action) {
  var _action$payload2 = action.payload,
      threadId = _action$payload2.threadId,
      agentId = _action$payload2.agentId;


  if ((0, _getTypingTimeoutIdForAgentInThread.getTypingTimeoutIdForAgentInThread)({
    threadId: '' + threadId,
    agentId: agentId,
    agentTypingStates: state
  })) {
    return (0, _updateIn2.default)(['' + threadId], (0, _omit2.default)([agentId]), state);
  }

  return state;
}), _agentTypingStatesRed);

exports.default = (0, _reduxActions.handleActions)(agentTypingStatesReducer, initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/typing-indicators/reducers/agentTypingStatesReducer.js
// module id = 895
// module chunks = 2 3